import { FormControl, InputLabel } from '@mui/material';

import MyDialog from "~/mui/MyDialog";
import { useTrans } from '~/hooks/useTrans';
import { apiUpdateProjectBillingMethod } from '~/providers/api';
import { IAdminProject, IAdminUpdateProjectBillingMethod } from "~/providers/admin-interfaces";
import { TProjectBillingMethod } from "~/providers/interfaces";
import { MySelect, MyMenuItem } from "~/mui/MySelect";
import { myUseState } from "~/hooks/myUseState";
import { useLang } from "~/hooks/useLang";

interface IState {
	dialogLoading: boolean;
	errorMsg: string;
	wasChanged: boolean;
}

interface IAdminChangeBillingMethodModal {
	projectData: IAdminProject;
	onSave?: (lastUpdate: string, billingMethod: IAdminProject["billingMethod"]) => void;
	onClose?: () => void;
	onChange?: (isChanged: boolean) => void;
}

export default function AdminChangeBillingMethodModal({
	projectData = null,
	onSave = () => {},
	onClose = () => {},
	onChange = () => {},
}: IAdminChangeBillingMethodModal) {
	const { trans, transBillingMethod } = useTrans();
	const { lang } = useLang();
	const { state, updateState } = myUseState<IState>({
		dialogLoading: false,
		errorMsg: "",
		wasChanged: false,
	});
	const { state: stateProject, updateState: updateStateProject } = myUseState<IAdminUpdateProjectBillingMethod>({
		billingMethod: projectData.billingMethod,
		lastUpdate: projectData.lastUpdate,
	});

	function getWasChanged(newState: Partial<IAdminUpdateProjectBillingMethod>): boolean {
		return newState.billingMethod !== projectData.billingMethod;
	}

	function updateStateProjectWithChange(newState: Partial<IAdminUpdateProjectBillingMethod>) {
		const wasChanged = getWasChanged(newState);

		updateStateProject(newState);
		updateState({
			wasChanged,
		});
		onChange(wasChanged);
	}

	async function dialogOnSave() {
		updateState({
			dialogLoading: true,
			errorMsg: "",
		});

		const updateData = await apiUpdateProjectBillingMethod(projectData.id, stateProject, lang);

		if (updateData.noErrors) {
			onSave(updateData.data.lastUpdate, updateData.data.billingMethod);
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: updateData.errors.join(", "),
			});
		}
	}

	return <MyDialog title={trans("adminChangeBillingMethodModal.title")} onClose={onClose} onSave={dialogOnSave} className="adminChangeBillingMethodModal" dialogLoading={state.dialogLoading} disableSave={!state.wasChanged}
		errorMsg={state.errorMsg} saveCaption={trans("saveChanges")} confirmClose={state.wasChanged} minWidth="300px">
		<FormControl sx={{ width: "100%" }}>
			<InputLabel>{ trans("adminChangeBillingMethodModal.title") }</InputLabel>
			<MySelect
				value={stateProject.billingMethod}
				onChange={event => updateStateProjectWithChange({ billingMethod: event.target.value as TProjectBillingMethod })}
				label={ trans("adminChangeBillingMethodModal.title") }
				sx={{ width: "100%" }}
				size="small"
			>
				<MyMenuItem value="none">{ transBillingMethod("none") }</MyMenuItem>
				<MyMenuItem value="sos">{ transBillingMethod("sos") }</MyMenuItem>
				<MyMenuItem value="barter">{ transBillingMethod("barter") }</MyMenuItem>
				<MyMenuItem value="wallet" disabled={true}>{ transBillingMethod("wallet") }</MyMenuItem>
			</MySelect>
		</FormControl>
	</MyDialog>;
}
